import { connect } from 'react-redux'
import { Component } from "macguffin"
import { findTexture, ImgFromTexture } from 'mc_pixi-fiber'

import PropTypes from 'prop-types'
import GameMode from '../../modes'
import GameModeGroup from '../../modes/GameModeGroup'

import BackgroundImage from "utils/BackgroundImage"

const showBoostsGroup = new GameModeGroup([GameMode.FREESPIN, GameMode.PICK])

const BOX_SCALE = 0.7
const BOX_SCALE_PORTRAIT = 0.95
const ICON_SCALE = 0.2
const VALUE_FONT_SCALE = 0.15
const TYPE_FONT_SCALE = 0.05
const TYPE_FONT_SCALE_PORTRAIT = 0.085
const BOOSTER_WIDTH = 0.2
const BOOSTER_WIDTH_PORTRAIT = 0.5

const boosterStyle = {
  position: "relative",
  backgroundPosition: "center",
  left: "10px"
}

@connect(state => ({
  collectedBoosts: state.game.collectedBoosts,
  currentPickResultData: state.game.currentPickResultData,
  currentGameMode: state.game.currentGameMode
}), {})
export default class BoosterStack extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  static propTypes = {
    currentGameMode: PropTypes.string,
  }

  componentWillMount() {
    this.setBoosts(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (showBoostsGroup.contains(nextProps.currentGameMode)) {
      this.setBoosts(nextProps)
    } else {
      this.setState({ picks: null })
    }
  }

  setBoosts = (props) => {
    const boosts = props.currentPickResultData || props.collectedBoosts

    if (!boosts) {
      return
    }

    const pickedBoosts = boosts.map(pickResult => {
      const { type, value } = pickResult.picks.find(pick => pick.picked)
      return { type, value }
    })

    const picks = pickedBoosts.reduce((acc, currentBoost) => {
      if (currentBoost.type !== "MULTIPLIER") {
        acc.push(currentBoost)
      } else {
        const multiplierBoost = acc.find(boost => boost.type === "MULTIPLIER")
        if (!multiplierBoost) {
          currentBoost.value += 1
          acc.push(currentBoost)
        } else {
          multiplierBoost.value += currentBoost.value
        }
      }
      return acc
    }, [])

    this.setState({ picks })
  }

  getType = (type) => {
    switch (type) {
      case 'REMOVE_SYMBOL':
        return this.t('freespins.picks.REMOVE_SYMBOL')

      case 'MULTIPLIER':
        return this.t('freespins.picks.MULTIPLIER')

      case 'ADD_WILDS':
        return this.t('freespins.picks.ADD_WILDS')


      default: break;
    }
  }

  getValue = (symbol) => {
    const { width, height } = this.props
    const size = width * ICON_SCALE

    if (symbol.type === 'MULTIPLIER') {
      const valueStyle = {
        fontSize: `${width * VALUE_FONT_SCALE}px`
      }

      return <h1 style={valueStyle}> {symbol.value}x </h1>
    }

    const texture = findTexture(symbol.type === 'ADD_WILDS' ? 'reel/symbols/normal/WR' : `reel/symbols/normal/L${11 - symbol.value}`)

    return <div className="boosterIcon">
      <ImgFromTexture texture={texture} width={size} height={size} />
    </div>
  }

  render() {
    const { props, state } = this
    const { width, height } = props
    const { picks = [] } = state
    const portrait = height > width

    const containerStyle = {
      width: `${width * (portrait ? BOX_SCALE_PORTRAIT : BOX_SCALE)}px`,
    }

    const infoStyle = {
      fontSize: `${width * (portrait ? TYPE_FONT_SCALE_PORTRAIT : TYPE_FONT_SCALE)}px`,
      right: `-25px`
    }

    const boosterSize = {
      height: `${width * (portrait ? BOOSTER_WIDTH_PORTRAIT : BOOSTER_WIDTH)}`,
      left: `none`
    }

    return (
      <div className="boosterStackContainer" style={containerStyle}>
        {picks && picks.map((symbol, index) => {
          if (symbol && symbol.type !== 'EXTRA_FUEL') {
            return (
              <BackgroundImage key={index} className="boosterStack" assetName="pickBoosterBackground" style={{ ...boosterStyle, ...boosterSize, top: `${index * (portrait ? 5 : 7)}vh` }}>
                {this.getValue(symbol)}
                <h2 style={infoStyle}> {this.getType(symbol.type)} </h2>
              </BackgroundImage>
            )
          }
        })}

      </div>

    )
  }
}
